import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const createWidgetToken = async (queryParams:any) => {
    try {
  return await get<ApiResponse<[]>>(`/trolley/recipient/widget?${queryParams}`).then((res)=>{
    if(res?.success===true) {
            return res
    }
    else {
            return null
    }
  })
}
catch(e){
HandleApiError(e)
}
};
